import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {List} from '@tickchak/react-share/app';
import {TShow} from '../../../../../hooks/useShow';
import {useTimetableDays} from '../../../hooks/useTimetableDays';
import DayListItem from '../../dayListItem/DayListItem';

interface DayPopupProps {
    show: TShow;
    controlled?: boolean;
}

const DayPopup: FC<DayPopupProps> = ({show, controlled = false}) => {
    const {t} = useTranslation('timetable');
    const {conferenceDays, currentDayIndex, onDaySelect, noDateCount, isLoadingLectures} = useTimetableDays({controlled});

    if(conferenceDays.length === 0) return null;

    const handleSelect = (i: number) => {
        onDaySelect(i);
        show.close();
    };

    return (
        <List
            show={show}
            data-cy="timetableDayPopup"
            position={{width: '320px', height: 'fit-content', minHeight: 'auto'}}
            ariaLabel={t('selectDayTitle')}
        >
            <List.Items>
                {conferenceDays.map((day, i) => (
                    <List.Item.Custom key={day.timestamp} id={String(i)}>
                        <DayListItem
                            label={day.label}
                            count={day.count}
                            loading={isLoadingLectures}
                            selected={i === currentDayIndex}
                            onClick={() => handleSelect(i)}
                            data-cy={`timetableDay-${day.timestamp}`}
                        />
                    </List.Item.Custom>
                ))}
                <List.Item.Custom id="-1">
                    <DayListItem
                        label={t('noDateLectures')}
                        count={noDateCount}
                        loading={isLoadingLectures}
                        selected={currentDayIndex === -1}
                        onClick={() => handleSelect(-1)}
                        data-cy="timetableDay-no-date"
                    />
                </List.Item.Custom>
            </List.Items>
            <List.Footer fixed>
                <List.Footer.Close text={t('close')} size="category" />
            </List.Footer>
        </List>
    );
};

export default DayPopup;
